import axios from 'axios'
const URL = process.env.REACT_APP_RAVEN_URL

export const getTemplate = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/template`,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const updateTemplate = (data) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'put',
      url: `${URL}/api/v1/template`,
      data: data,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const getStaticPages = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/config/static-pages`,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const updateStaticPages = (data, pageId) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'put',
      url: `${URL}/api/v1/config/static-pages?static_page_id=${pageId}`,
      data: data,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}
